import * as React from 'react';
import { InlineText1 } from '@cian/ui-kit';

import * as styles from './styles.css';
import { Link } from '../Link';

interface IOffersFooterProps {
  fromAgentsPropsCountDisplay: string;
  fromAgentsPropsCountUrl: string;
  propsCountDisplay: string;
  propsCountUrl: string;
  isHouseSelected: boolean;
  onAgentOffersLinkClick(): void;
  onAllOffersLinkClick(): void;
}

export function OffersFooter({
  fromAgentsPropsCountDisplay,
  fromAgentsPropsCountUrl,
  propsCountDisplay,
  propsCountUrl,
  isHouseSelected,
  onAgentOffersLinkClick,
  onAllOffersLinkClick,
}: IOffersFooterProps) {
  return (
    <div className={styles['container']}>
      {fromAgentsPropsCountDisplay && (
        <InlineText1>
          <Link
            url={fromAgentsPropsCountUrl}
            target="blank"
            onClick={onAgentOffersLinkClick}
          >{`Посмотреть ${fromAgentsPropsCountDisplay}`}</Link>
          {' от агентов и собственников'}
        </InlineText1>
      )}
      <div className={styles['count']}>
        <InlineText1>
          Всего{' '}
          <Link url={propsCountUrl} target="blank" data-testid="AllOffersLink" onClick={onAllOffersLinkClick}>
            {propsCountDisplay}
          </Link>
          {isHouseSelected ? ' в этом корпусе' : ' в ЖК'}
        </InlineText1>
      </div>
    </div>
  );
}
